import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component, effect,
  input,
  InputSignal,
  InputSignalWithTransform,
  output,
  OutputEmitterRef, signal,
  Signal, WritableSignal
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from "@angular/material/icon";
import { toSignal } from "@angular/core/rxjs-interop";
import { debounceTime, distinctUntilChanged, tap } from "rxjs";
import { MatAutocomplete, MatAutocompleteTrigger, MatOption } from "@angular/material/autocomplete";
import { MatInput } from "@angular/material/input";
import { MatIconButton } from "@angular/material/button";

@Component({
  selector: 'soph-search-bar',
  standalone: true,
  imports: [
    MatIcon,
    ReactiveFormsModule,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatInput,
    MatOption,
    MatIconButton
  ],
  templateUrl: './search-bar.component.html',
  styleUrl: './search-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class SearchBarComponent< T, K extends keyof T = keyof T > {

  public searchCtrl: FormControl< string > = new FormControl();
  public error: WritableSignal< string | null > = signal( null );
  public searchSignal: Signal< string > = toSignal(
    this.searchCtrl.valueChanges.pipe(
      debounceTime( 300 ),
      distinctUntilChanged()
    ),
    { initialValue: '' }
  );

  public filteredList: InputSignal<T[] | null> = input<T[] | null>(null);
  public placeholder: InputSignal<string> = input<string>( 'Búsqueda' );
  public idKey: InputSignal< string > = input<string>('id');
  public labelKey: InputSignal< string > = input<string>('label');
  public shouldEmitId: InputSignalWithTransform< boolean, unknown > = input( false, { transform: booleanAttribute });

  public onSelectedOption: OutputEmitterRef< T | T[K]> = output<T | T[K]>();
  public onSearchChange: OutputEmitterRef< string > = output<string>();

  public onSelect( selected: T ) {
    this.searchCtrl.setValue( selected[ this.labelKey() as K ] as string, { emitEvent: false });
    this.onSelectedOption.emit( this.shouldEmitId() ? selected[ this.idKey() as K ] : selected );
  }

  public onSearchEffect = effect(() => {
    const textoQueTecleo = this.searchSignal();
    this.onSearchChange.emit( textoQueTecleo );
  });

  public onClear() {
    this.searchCtrl.setValue('');
    this.onSearchChange.emit('');
  }

  public getIdValue( option: T ): string {
    return option[ this.idKey() as K ] as string ?? '';
  }

  public getLabelValue( option: T ): string {
    return option[ this.labelKey() as K ] as string ?? '';
  }
}
